import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SigninRoutingModule } from './signin-routing.module';
import { SigninComponent } from 'src/app/components/signin/signin.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxCaptchaModule} from 'ngx-captcha';
import { SharedModule } from '../shared/shared.module';
import { ForgotMyPasswordDialog } from 'src/app/components/signin/forgot-my-password-dialog/forgot-my-password-dialog';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [
    SigninComponent,
    ForgotMyPasswordDialog
  ],
  imports: [
    CommonModule,
    SharedModule,
    SigninRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgxCaptchaModule,
    MatDialogModule
  ]
})
export class SigninModule { }